import Enum from "../../../../enums/Enum";


const IntakeFormGenderEnum = new Enum({
    MALE: {name: "Male", nameInArabic:"ذكر"},
    FEMALE: {name: "Female", nameInArabic:"أنثى"}
});

export default IntakeFormGenderEnum;